import { useState } from "react";
import { PageCopy, PageIndex, PageMedia } from "../components/site/PagePrimitives";
import "./pages.css";

const phases = [
  { label: "PASS", cn: "传球", note: "先看见队友，再送出球。" },
  { label: "TURN", cn: "转身", note: "稳住核心，找到新的方向。" },
  { label: "SHOOT", cn: "射门", note: "相信动作，也接受下一次练习。" }
];

export function TrainingPage() {
  const [phase, setPhase] = useState(0);
  const current = phases[phase];

  return (
    <article className={`experience-page page-training training-phase-${phase}`} aria-labelledby="training-title">
      <PageMedia src="/assets/athlete/training-throw.webp" alt="" className="page-media--training" />
      <PageIndex number="03" label="TRAINING" />
      <PageCopy className="training-copy">
        <p className="page-kicker">ONE MOVE AT A TIME</p>
        <h1 id="training-title">练好一个动作，<br />再去挑战下一个。</h1>
        <p aria-live="polite">{current.note}</p>
      </PageCopy>

      <section className="training-scrubber" aria-label="训练动作分解">
        <div className="training-scrubber__labels">
          {phases.map((item, index) => (
            <button
              key={item.label}
              type="button"
              className={phase === index ? "is-active" : ""}
              onClick={() => setPhase(index)}
              aria-pressed={phase === index}
            >
              <strong>{item.label}</strong>
              <span>{item.cn}</span>
            </button>
          ))}
        </div>
        <input
          type="range"
          min="0"
          max="2"
          step="1"
          value={phase}
          onChange={(event) => setPhase(Number(event.currentTarget.value))}
          aria-label="拖动选择训练动作"
        />
        <div className="training-film" aria-hidden="true">
          <img src="/assets/athlete/journey-depth.webp" alt="" />
          <img src="/assets/athlete/home-impact.webp" alt="" />
          <img src="/assets/athlete/training-throw.webp" alt="" />
        </div>
      </section>
    </article>
  );
}
